import { render, staticRenderFns } from "./WidgetMenu.vue?vue&type=template&id=a463c2f2&"
import script from "./WidgetMenu.vue?vue&type=script&lang=js&"
export * from "./WidgetMenu.vue?vue&type=script&lang=js&"
import style0 from "./WidgetMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetMenu.vue"
export default component.exports